<template>
  <div class="container">
    <div class="row">
      <div class="col-12 form-group form-group-sm">
        <label class="label" for="tarjetaa">Datos de tarjeta</label>
        <div class="card">
          <div class="card-body row">
            <div class="col-12 col-md-10 form-group form-group-sm">
              <label class="label" for="tarjetaa">Número de tarjeta</label>
              <input
                id="tarjetaa"
                :class="`form-control form-control-sm text-center bg-white`"
                style="cursor: text"
                type="text"
                v-model="numeroDeTarjeta"
              />
            </div>
            <div
              class="col-12 col-md-2 form-group form-group-sm d-flex align-items-end"
            >
              <button class="btn btn-danger" type="button" @click="borrarDatos">
                Borrar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModificarTarjetaForm",
  props: ["idCobranzaLugarDePago"],
  computed: {
    numeroDeTarjeta: {
      get() {
        return this.$store.state.clientes.ModificarCliente.nroTarjeta;
      },
      set(val) {
        this.$store.commit("clientes/ModificarCliente/setNroTarjeta", val);
      },
    },
    tipoTarjeta: {
      get() {
        return this.$store.state.clientes.ModificarCliente.tipoTarjeta;
      },
      set(val) {
        this.$store.commit("clientes/ModificarCliente/setTipoTarjeta", val);
      },
    },
  },
  methods: {
    borrarDatos() {
      this.numeroDeTarjeta = "";
    },
  },
};
</script>
